import {
  AiInsight,
  BaseImage,
  CodeOutlined,
  DevDependency,
  DirectDependency,
  ExploitIconsGroup,
  ExploitValidated,
  Fix,
  FolderOutlined,
  FunctionExecuted,
  GlobalOutlined,
  IndirectDependency,
  Ingress,
  InternetFacing,
  NodeIndexOutlined,
  PublicImage,
  Remediation,
  Runtime,
  SafetyCertificateOutlined,
  ThirdParty
} from "@/icons"

import { ExploitMaturity } from "@/domain/issue"

export const EXPLOITABILITY_KEY = "exploitability"

export const ICONS_INSIGHTS = {
  // EVP verdict. Only the demo passes a value for it, so it stays hidden elsewhere.
  exploitable: {
    key: "exploitable",
    Icon: ExploitValidated
  },
  runtime: {
    key: "runtime",
    Icon: Runtime
  },
  functionExecuted: {
    key: "executed",
    Icon: FunctionExecuted
  },
  ingress: {
    key: "ingress",
    Icon: Ingress
  },
  isDirect: {
    key: "isDirect",
    Icon: DirectDependency
  },
  isIndirect: {
    key: "isIndirect",
    Icon: IndirectDependency
  },
  fromBaseImage: {
    key: "fromBaseImage",
    Icon: BaseImage
  },
  fromThirdParty: {
    key: "fromThirdParty",
    Icon: ThirdParty
  },
  isThirdParty: {
    key: "isThirdParty",
    Icon: ThirdParty
  },
  [EXPLOITABILITY_KEY]: {
    POC: {
      key: `${EXPLOITABILITY_KEY}.POC`,
      Icon: ExploitIconsGroup.POC
    },
    IN_THE_WILD: {
      key: `${EXPLOITABILITY_KEY}.IN_THE_WILD`,
      Icon: ExploitIconsGroup.IN_THE_WILD
    }
  },
  internetFacing: {
    key: "internetFacing",
    Icon: InternetFacing
  },
  publicImage: {
    key: "publicImage",
    Icon: PublicImage
  },
  isDevDependency: {
    key: "isDevDependency",
    Icon: DevDependency
  },
  hasFixVersion: {
    key: "hasFixVersion",
    Icon: Fix
  },
  hasKodemRemediation: {
    key: "hasKodemRemediation",
    Icon: Remediation
  },
  aiInsight: {
    key: "aiRelated",
    Icon: AiInsight
  },
  hasGuardrails: {
    key: "hasGuardrails",
    Icon: SafetyCertificateOutlined
  },
  isRoot: {
    key: "isRoot",
    Icon: NodeIndexOutlined
  },
  networkAccess: {
    key: "networkAccess",
    Icon: GlobalOutlined
  },
  fileSystemAccess: {
    key: "fileSystemAccess",
    Icon: FolderOutlined
  },
  executionAccess: {
    key: "executionAccess",
    Icon: CodeOutlined
  }
}

export const getExploitabilityByKeys = (
  value: ExploitMaturity | ExploitMaturity[]
) => {
  if (Array.isArray(value)) {
    return value.reduce(
      (acc, item) => {
        acc[`${EXPLOITABILITY_KEY}.${item}`] = true

        return acc
      },
      {} as Record<string, boolean>
    )
  }

  return { [`${EXPLOITABILITY_KEY}.${value}`]: true }
}
